export default __webpack_public_path__ + "media/zurb/img/work/iqtell-thumb2-2b5db995c7e5b22fe0e43057dc39d219.png";